import {
  ListStacksResponseItem,
  MeasurementCardResponse,
} from '../../.generated/admin-api';
import { FieldValueState } from '../../components/registrationFlow';
import { ClearUserCacheAction } from '../types';

export interface LocalStack {
  id: string;
  departmentId: string;
  measurementCardId: string;
  fieldValues: Record<string, unknown>;
  stackNumber: string;
  date: string;
  uploadInProgress: boolean;
}

export interface DepartmentStackState {
  organizationId: string;
  measurementCard?: MeasurementCardResponse;
  reservedStackNumbers?: number[];
  stackList?: Array<ListStacksResponseItem>;
  localStacks?: Record<string, LocalStack>;
  fieldValues?: FieldValueState[]; // current pre-registration field values
  basicDataFieldValues?: Record<string, unknown>; // autofill values from latest pre-registration.
  lastUpdated?: string;
}

export interface StackState {
  departments: Record<string, DepartmentStackState>;
}
export const CLEAR_STACKS = 'CLEAR_STACKS';
export const GET_STACKS = 'GET_STACKS';
export const GET_MEASUREMENT_CARD = 'GET_MEASUREMENT_CARD';
export const UPDATE_RESERVED_STACK_NUMBERS = 'UPDATE_RESERVED_STACK_NUMBERS';
export const REMOVE_PICKED_STACK_NUMBER = 'REMOVE_PICKED_STACK_NUMBER';
export const CREATE_STACK = 'CREATE_STACK';
export const UPLOAD_STACK = 'UPLOAD_STACK';
export const UPLOAD_STACK_SUCCESS = 'UPLOAD_STACK_SUCCESS';
export const UPLOAD_STACK_FAILED = 'UPLOAD_STACK_FAILED';
export const CLEAR_FIELD_VALUES = 'CLEAR_FIELD_VALUES';
export const UPDATE_FIELD_VALUE = 'UPDATE_FIELD_VALUE';
export const SET_FIELD_VALUES = 'SET_FIELD_VALUES';

export interface ClearStacksAction {
  type: typeof CLEAR_STACKS;
}

interface GetStacksAction {
  type: typeof GET_STACKS;
  departmentId: string;
  stacks: ListStacksResponseItem[];
}

interface GetMeasurementCardAction {
  type: typeof GET_MEASUREMENT_CARD;
  departmentId: string;
  measurementCard: MeasurementCardResponse;
}

interface UpdateReservedStackNumbersAction {
  type: typeof UPDATE_RESERVED_STACK_NUMBERS;
  departmentId: string;
  reservedStackNumbers: number[];
}

interface RemovePickedStackNumberAction {
  type: typeof REMOVE_PICKED_STACK_NUMBER;
  departmentId: string;
  stackNumber: number;
}

interface CreateStackAction {
  type: typeof CREATE_STACK;
  departmentId: string;
  measurementCardId: string;
  fieldValues: Record<string, unknown>;
  stackNumber: string;
  date: string;
}

interface UploadStackAction {
  type: typeof UPLOAD_STACK;
  departmentId: string;
  localStackId: string;
}

interface UploadStackSuccessAction {
  type: typeof UPLOAD_STACK_SUCCESS;
  departmentId: string;
  localStackId: string;
}

interface UploadStackFailedAction {
  type: typeof UPLOAD_STACK_FAILED;
  departmentId: string;
  localStackId: string;
}

export interface SetFieldValuesAction {
  type: typeof SET_FIELD_VALUES;
  departmentId: string;
  values: FieldValueState[];
}

export interface ClearFieldValuesAction {
  type: typeof CLEAR_FIELD_VALUES;
  departmentId: string;
}

export interface UpdateFieldValueAction {
  type: typeof UPDATE_FIELD_VALUE;
  departmentId: string;
  field: FieldValueState;
}

export type StackActionTypes =
  | GetStacksAction
  | GetMeasurementCardAction
  | UpdateReservedStackNumbersAction
  | RemovePickedStackNumberAction
  | CreateStackAction
  | UploadStackAction
  | UploadStackSuccessAction
  | UploadStackFailedAction
  | ClearStacksAction
  | ClearUserCacheAction
  | SetFieldValuesAction
  | ClearFieldValuesAction
  | UpdateFieldValueAction;
